export default __webpack_public_path__ + "static/media/apply-flow.8d5fdc73.png";